module.exports = __webpack_public_path__ + "static/img/7.8e932f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/7.png
// module id = Xr7h
// module chunks = 0